<template>
  <app-modal
    :modal-id="modalId"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">Habilitar Replanificación para Gestor Técnico </h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`treasury/elaborateProforma/replanning/store`"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label class="mb-0">Replanificar</label>
              <app-input
                type="radio-buttons"
                v-model="inputs.is_replanning"
                :list="isActive"
              />
            </div>
          </div>
          
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { axiosGet } from "@/app/helpers/AxiosHelper";

export default {
  name: "ReplanningModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    evalTestId: Number,
  },
  data() {
    return {
      preloader: false,
      modalId: "replaning-info-modal",
      inputs: {},
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
    };
  },
  created() {
    this.dataEval();
    
  },
  methods: {
    dataEval() {
      this.preloader = true;
      let url = `/treasury/elaborateProforma/replanning/show/${this.evalTestId}`;
      axiosGet(url)
        .then((response) => {
          if (response.status === 200) {
            this.inputs = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.preloader = false;
        });
    },
    submit() {   
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(this.$t("updated_success"));
      this.$hub.$emit("reload-" + this.tableId);
    },
  },
};
</script>

<style>
</style>
